module.exports = "/_next/static/media/f1f3c3a5c56c8f2e9aabaa180b260b01.png";